import React, { useContext } from 'react'
import AnnouncementListItems from './AnnouncementListItems'
import { AnnouncementListSection } from './styles'
import { MText, MView } from 'styles/mobilePageStyles'
import { ThemeContext } from '../../../../../theme/ThemeProvider'
import useInfiniteScrolling from 'utils/useInfiniteScrolling'

const AnnouncementList = ({
	list,
	setList,
	page,
	setPage,
	show,
	setShow,
	search,
	count,
	searchshow = false,
}) => {
	const { textsilver } = useContext(ThemeContext).theme.COLORS
	const [observerRef, setObserverRef] = React.useState<null | HTMLDivElement>(null);

	const fetchMore = React.useCallback(() => {
		// 다음 페이지로 이동만 하고, 실제 데이터 fetching은 상위 컴포넌트에서 처리
		setPage(prevPage => prevPage + 1);
	}, [setPage]);

	useInfiniteScrolling({
		observerRef,
		fetchMore,
		hasMore: list.length < count,
	});

	return (
		<AnnouncementListSection
			style={{
				height: 570,
				overflow: 'auto',
				borderTopLeftRadius: 10,
				borderTopRightRadius: 10,
				paddingTop: 15,
				paddingLeft: 5,
			}}>
			{list?.length ? (
				list?.map((item, index) => (
					<AnnouncementListItems
						key={item.id.toString()}  // index 대신 고유 id 사용
						item={item}
						index={index}
						show={show}
						setShow={setShow}
						searchshow={searchshow}
					/>
				))
			) : (
				<MView style={{ padding: 20 }}>
					<MText style={{ color: textsilver }}>
						공지가 없습니다.
					</MText>
				</MView>
			)}

			<div
				style={{ height: '10px', marginBottom: '20px' }}
				ref={setObserverRef}
			></div>
		</AnnouncementListSection>
	)
}

export default AnnouncementList
